import React from 'react'
import { Card ,Button,notification,Divider} from 'antd'
import { Table } from "semantic-ui-react"
import { Badge } from 'antd';
import { BellOutlined} from '@ant-design/icons';

export default function MainFee() {
    const openNotificationWithIcon = type => {
        notification[type]({
          message: 'Notification Title',
          description:
            'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
        });
      };
      
    return (
        <div>
            
             
   <Badge.Ribbon text="Notice" className="site-badge-count-109" count={109} style={{ backgroundColor: '#52c41a' }} >
    <Card>
    <Button type="primary" onClick={() => openNotificationWithIcon('success')}>
    Last Date to pay Fee
  </Button>
 &nbsp;&nbsp; <Button type="primary" onClick={() => openNotificationWithIcon('success')}>
     Fee Guidelines
  </Button>
 </Card>

  </Badge.Ribbon>
  <Divider
            orientation="left" plain style={{ fontSize: '16px', color: '#08c' }}>
            <BellOutlined  style={{ fontSize: '16px', color: '#08c' }} >
                </BellOutlined> &nbsp;&nbsp;Current Fee Status</Divider>
                <Table color="orange" key="orange">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Fee Detail </Table.HeaderCell>
            <Table.HeaderCell> 	TransactionId </Table.HeaderCell>
            <Table.HeaderCell> 	Amount </Table.HeaderCell>
            <Table.HeaderCell> Last	Date </Table.HeaderCell>
            <Table.HeaderCell> 	Staus </Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          <Table.Row>
            <Table.Cell> - </Table.Cell>
            <Table.Cell>- </Table.Cell>
            <Table.Cell>-</Table.Cell>
            <Table.Cell>-</Table.Cell>
            <Table.Cell> No Pending Dues</Table.Cell>

          </Table.Row>
        
        </Table.Body>
      </Table>
  <Divider
            orientation="left" plain style={{ fontSize: '16px', color: '#08c' }}>
            <BellOutlined  style={{ fontSize: '16px', color: '#08c' }} >
                </BellOutlined> &nbsp;&nbsp;Last 5 Tranctions</Divider>
  <Table color="green" key="green">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Fee Detail </Table.HeaderCell>
            <Table.HeaderCell> 	TransactionId </Table.HeaderCell>
            <Table.HeaderCell> 	Amount </Table.HeaderCell>
            <Table.HeaderCell> 	Date </Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          <Table.Row>
            <Table.Cell>Apples</Table.Cell>
            <Table.Cell>200</Table.Cell>
            <Table.Cell>200</Table.Cell>
            <Table.Cell>0g</Table.Cell>
         
          </Table.Row>
        
        </Table.Body>
      </Table>
   

        </div>
    )
}
